module.exports = __webpack_public_path__ + "static/media/csv-download.9f77d9d7.svg";